var path = 'scripts/views/components/receipt-billing-cycle-input.html';
var html = "<div class=\"modal-billing-cycles\">\n    <select class=\"form-control em-bold\"\n            id=\"billing-cycle-dropdown\"\n            ng-options=\"billingCycle.formattedCycle for billingCycle in $ctrl.billingCycles track by billingCycle.endDate\"\n            ng-model=\"$ctrl.currentBillingCycle\"\n            ng-change=\"$ctrl.onBillingCycleChange({billingCycle: $ctrl.currentBillingCycle})\">\n    </select>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/receipt-billing-cycle-input.html
// module id = 335
// module chunks = 0